export interface IFeature {
    name: string;
    defaultValue: boolean | string | number;
    portalShell?: boolean;
}

export const FeaturesDefinitions: Record<string, IFeature> = {
    /**
   * Service feature flags
   */
    EnableServiceAifabric: {
        name: 'enable-service-aifabric',
        defaultValue: true,
    },

    EnableServiceAcademy: {
        name: 'enable-service-academy',
        defaultValue: false,
    },

    EnableServiceDocs: {
        name: 'enable-service-docs',
        defaultValue: false,
    },

    EnableServiceCustomerPortal: {
        name: 'enable-service-customerportal',
        defaultValue: false,
    },

    EnableServiceOrchestrator: {
        name: 'enable-service-orchestrator',
        defaultValue: false,
    },

    EnableServiceChatbots: {
        name: 'enable-service-chatbots',
        defaultValue: false,
    },

    EnableServiceTestmanager: {
        name: 'enable-service-testmanager',
        defaultValue: false,
    },

    EnableServiceInsights: {
        name: 'enable-service-insights',
        defaultValue: false,
    },

    EnableServiceFpst: {
        name: 'enable-service-fpst',
        defaultValue: false,
    },

    /** Enables external user licensing */
    EnableExternalUserLicense: {
        name: 'EnableExternalUserLicense',
        defaultValue: false,
    },

    EnableGroupQuotaManagement: {
        name: 'EnableGroupQuotaManagement',
        defaultValue: false,
    },

    // Required for testing, do not remove
    EnableEnforceTestConnectionforAAD: {
        name: 'enableEnforceTestConnectionforAAD',
        defaultValue: true,
    },

    EnableSmartlingIntegration: {
        name: 'EnableSmartlingIntegration',
        defaultValue: false,
    },

    /** Support for Toggling Feature Flags in LocalStorage */
    // Required for testing, do not remove
    EnableLocalStorageFeatureFlags: {
        name: 'EnableLocalStorageFeatureFlags',
        defaultValue: false,
    },

    EnableRecreateDefaultTenant: {
        name: 'enableRecreateDefaultTenant',
        defaultValue: false,
    },

    /** Enable Ecommerce integration */
    EnableEcommerceIntegration: {
        name: 'enableEcommerceIntegration',
        defaultValue: true,
    },

    /** Enable Ecommerce in US */
    EnableEcommerceInUs: {
        name: 'enableEcommerceInUs',
        defaultValue: true,
    },

    /** Enable Ecommerce in Europe */
    EnableEcommerceInEurope: {
        name: 'enableEcommerceInEurope',
        defaultValue: true,
    },

    /** Enable Ecommerce in World */
    EnableEcommerceInWorld: {
        name: 'enableEcommerceInWorld',
        defaultValue: true,
    },

    /** Enable Ecommerce in Japan */
    EnableEcommerceInJapan: {
        name: 'enableEcommerceInJapan',
        defaultValue: true,
        portalShell: true,
    },

    /** Enabled Ecommerce - Remove disableAutoFocus, disableEnforceFocus, disableRestoreFocus
     * from checkout component form as part of PLT-17057 */
    EnableEcommerceRemoveFocusProps: {
        name: 'enableEcommerceRemoveFocusProps',
        defaultValue: false,
    },

    /** Enabled Ecommerce - new Plan Selection page format  */
    EnableEcommercePlanSelectionRevampM0: {
        name: 'enableEcommercePlanSelectionRevampM0',
        defaultValue: true,
        portalShell: true,
    },

    /** Enable Ecommerce - Romania is accepted as billing country PLT-80146 */
    // TODO//PLT-63301//enableEcommerceBillingFromRomania//remove me
    EnableEcommerceBillingFromRomania: {
        name: 'enableEcommerceBillingFromRomania',
        defaultValue: false,
        portalShell: true,
    },

    EnableAbTestingSupport: {
        name: 'enableAbTestingSupport',
        defaultValue: true,
        portalShell: true,
    },

    /** Enabled Ecommerce - Cart abandonment PLT-39634 */
    EnableEcommerceCartAbandonmentCampaign: {
        name: 'enableEcommerceCartAbandonmentCampaign',
        defaultValue: true,
    },

    /** Enabled Ecommerce - Current Cycle Prices PLT-41446 */
    EnableEcommerceCurrentCyclePrices: {
        name: 'enableEcommerceCurrentCyclePrices',
        defaultValue: true,
    },

    /** Enabled Ecommerce - Annual Robot Units PLT-54100 */
    enableEcommerceAnnualRobotUnits: {
        name: 'enableEcommerceAnnualRobotUnits',
        defaultValue: true,
    },

    EnableGovernanceModuleFederation: {
        name: 'enableGovernanceModuleFederation',
        defaultValue: false,
    },

    EnableAiTrustLayerContextGrounding: {
        name: 'EnableAiTrustLayerContextGrounding',
        defaultValue: false,
    },

    EnableAiTrustLayerMoveContextGrounding: {
        name: 'EnableAiTrustLayerMoveContextGrounding',
        defaultValue: false,
    },

    EnableContextGroundingSubfolderLookupGlobPattern: {
        name: 'EnableContextGroundingSubfolderLookupGlobPattern',
        defaultValue: false,
    },

    DisableContextGroundingIntegrationServices: {
        name: 'DisableContextGroundingIntegrationServices',
        defaultValue: false,
    },

    EnableAiTrustLayerAudit: {
        name: 'EnableAiTrustLayerAudit',
        defaultValue: false,
    },

    EnableAiTrustLayerUsage: {
        name: 'EnableAiTrustLayerUsage',
        defaultValue: false,
    },

    EnableAiTrustLayerA4E: {
        name: 'EnableAiTrustLayerA4E',
        defaultValue: false,
    },

    EnableAiTrustLayerByoLlm: {
        name: 'EnableAiTrustLayerByoLlm',
        defaultValue: false,
    },

    EnableAiTrustLayerByoLlmV2: {
        name: 'EnableAiTrustLayerByoLlmV2',
        defaultValue: false,
    },

    EnableAiTrustLayerByoLlmUiAgent: {
        name: 'EnableAiTrustLayerByoLlmUiAgent',
        defaultValue: false,
    },

    AiTrustLayerByoLlmScreenPlayGa: {
        name: 'AiTrustLayerByoLlmScreenPlayGa',
        defaultValue: false,
    },

    AiTrustLayerByoLlmSemanticTargetingGa: {
        name: 'AiTrustLayerByoLlmSemanticTargetingGa',
        defaultValue: false,
    },

    EnableAiTrustLayerByoLlmIXP: {
        name: 'EnableAiTrustLayerByoLlmIXP',
        defaultValue: false,
    },

    EnableAiTrustLayerByoLlmAmazonWebServices: {
        name: 'EnableAiTrustLayerByoLlmAmazonWebServices',
        defaultValue: false,
    },

    EnableAiTrustLayerByoLlmConfigurationName: {
        name: 'EnableAiTrustLayerByoLlmConfigurationName',
        defaultValue: false,
    },

    EnableAiTrustLayerByoLlmConfigurationsV2: {
        name: 'EnableAiTrustLayerByoLlmConfigurationsV2',
        defaultValue: false,
    },

    EnableAiTrustLayerByoLlmV2CustomConnectors: {
        name: 'EnableAiTrustLayerByoLlmV2CustomConnectors',
        defaultValue: false,
    },

    EnableAiTrustLayerOtelConfigurations: {
        name: 'EnableAiTrustLayerOtelConfigurations',
        defaultValue: false,
    },

    AiTrustLayerByoModelEnabledProducts: {
        name: 'AiTrustLayerByoModelEnabledProducts',
        defaultValue: JSON.stringify([]),
    },

    EnableAllConnectorsForAiTrustLayerByoModel: {
        name: 'EnableAllConnectorsForAiTrustLayerByoModel',
        defaultValue: false,
    },

    AiTrustLayerByoLlmBypassConfigurationUniqueness: {
        name: 'AiTrustLayerByoLlmBypassConfigurationUniqueness',
        defaultValue: false,
    },

    EnableAiTrustLayerByoAiGateway: {
        name: 'EnableAiTrustLayerByoAiGateway',
        defaultValue: false,
    },

    AiTrustLayerByoAiGatewayCustomConnectors: {
        name: 'AiTrustLayerByoAiGatewayCustomConnectors',
        defaultValue: JSON.stringify([]),
    },

    EnableAiTrustLayerByoForPassthrough: {
        name: 'EnableAiTrustLayerByoForPassthrough',
        defaultValue: false,
    },

    EnableAiTrustLayerByoLlmFolderDropdown: {
        name: 'EnableAiTrustLayerByoLlmFolderDropdown',
        defaultValue: false,
    },

    EnableAiTrustLayerGovernance: {
        name: 'EnableAiTrustLayerGovernance',
        defaultValue: false,
    },

    EnableAiTrustLayerPricingRevamp: {
        name: 'EnableAiTrustLayerPricingRevamp',
        defaultValue: false,
    },

    EnableAiTrustLayerVendorTermsUpdatedBanner: {
        name: 'EnableAiTrustLayerVendorTermsUpdatedBanner',
        defaultValue: false,
    },

    EnableA4EToolsPanel: {
        name: 'EnableA4EToolsPanel',
        defaultValue: false,
    },

    EnableA4EDUCheck: {
        name: 'EnableA4EDUCheck',
        defaultValue: true,
    },

    EnableA4EUserLicenseManagementCheck: {
        name: 'EnableA4EUserLicenseManagementCheck',
        defaultValue: true,
    },

    EnableA4EAnthropicCheck: {
        name: 'EnableA4EAnthropicCheck',
        defaultValue: true,
    },

    EnableA4EForceProcessDeployment: {
        name: 'EnableA4EForceProcessDeployment',
        defaultValue: false,
    },

    EnableA4EInsightsIntegration: {
        name: 'EnableA4EInsightsIntegration',
        defaultValue: false,
    },

    EnableA4EFallbackOnAIUnits: {
        name: 'EnableA4EFallbackOnAIUnits',
        defaultValue: false,
    },
    EnableA4EOutputFormatSuggestion: {
        name: 'EnableA4EOutputFormatSuggestion',
        defaultValue: false,
    },
    EnableA4ESpecializedAutopilot: {
        name: 'enableA4ESpecializedAutopilot',
        defaultValue: false,
    },
    EnableA4ESendCustomFeedback: {
        name: 'EnableA4ESendCustomFeedback',
        defaultValue: false,
    },
    EnableA4EMaintenanceMode: {
        name: 'EnableA4EMaintenanceMode',
        defaultValue: false,
    },
    EnableA4ERequestClassification: {
        name: 'EnableA4ERequestClassification',
        defaultValue: false,
    },
    EnableA4EECSQueryRewrite: {
        name: 'EnableA4EECSQueryRewrite',
        defaultValue: false,
    },
    EnableA4ETabularQuery: {
        name: 'EnableA4ETabularQuery',
        defaultValue: false,
    },
    EnableA4ESendFeedbackToUiPath: {
        name: 'EnableA4ESendFeedbackToUiPath',
        defaultValue: false,
    },
    EnableA4EAlternateStartupAgent: {
        name: 'EnableA4EAlternateStartupAgent',
        defaultValue: false,
    },

    /** Enabled Ecommerce - Billing Address Validation - Address Autocomplete */
    EnableEcommerceAddressBillingValidation: {
        name: 'enableEcommerceAddressBillingValidation',
        defaultValue: true,
    },

    /** Enabled Ecommerce - Annual Renewal Decrease - Allow decrease */
    EnableEcommerceAnnualRenewalDecrease: {
        name: 'enableEcommerceAnnualRenewalDecrease',
        defaultValue: false,
    },
    /** Enable Ecommerce - Better Purchase Experience - Can reach public pages */
    EnableEcommerceBetterPurchaseExpM0: {
        name: 'enableEcommerceBetterPurchaseExpM0',
        defaultValue: false,
    },

    /** Enable Ecommerce - Pricing V2 - Updated UI Layout */
    EnableEcommercePricingV2: {
        name: 'enableEcommercePricingV2',
        defaultValue: false,
    },

    /** Enable Ecommerce - Update license quantity */
    EnableEcommerceUpdateLicenseQuantity: {
        name: 'enableEcommerceUpdateLicenseQuantity',
        defaultValue: true,
    },

    /** Enable using packages from CDN */
    EnableCdnPackage: {
        name: 'enable-cdn-package',
        defaultValue: false,
    },

    /** Enable using backup CDN for apollo-packages */
    EnableApolloBackupCdn: {
        name: 'enable-apollo-backup-cdn',
        defaultValue: false,
    },

    /** Enable per cloud env CDN for apollo-packages */
    EnableApolloPerEnvCdn: {
        name: 'enable-apollo-per-env-cdn',
        defaultValue: false,
    },

    /** Portal-shell package version */
    /* You MUST include the hash at the end for it to work */
    PortalShellVersion: {
        name: 'portal-shell-version',
        defaultValue: '3.266.2',
    },

    /** Apollo-fonts package version */
    ApolloFontsVersion: {
        name: 'apollo-fonts-version',
        defaultValue: '1.25.1',
    },

    /* Enable Airgapped license activation for gov */
    EnableAirgappedLicenseActivation: {
        name: 'GovCloudOperation.UseAirgappedLicenseActivation',
        defaultValue: false,
    },

    /* Enable online license activation for gov */
    UseOnlineLicenseActivation: {
        name: 'GovCloudOperation.UseOnlineLicenseActivation',
        defaultValue: false,
    },

    // False in all envs
    ShowServerllessControlPlane: {
        name: 'show-serverlesscontrolplane',
        defaultValue: false,
    },

    /** Disable features for gov cloud */
    DisableFeatureFedRamp: {
        name: 'disable-feature-fed-ramp',
        defaultValue: false,
    },

    /** Enable notification settings page */
    EnableNotificationSettings: {
        name: 'enableNotificationSettings',
        defaultValue: true,
        portalShell: true,
    },
    /** Enable notification page using wrapper component */
    EnableNotificationsPageV2: {
        name: 'enableNotificationsPageV2',
        defaultValue: false,
        portalShell: true,
    },

    /** Enable slack notification mode */
    EnableSlackNotification: {
        name: 'EnableSlackNotification',
        defaultValue: false,
        portalShell: true,
    },
    /** Enable slack notification channel mode */
    EnableSlackChannelNotification: {
        name: 'EnableSlackChannelNotification',
        defaultValue: false,
    },

    EnableTeamsNotification: {
        name: 'EnableTeamsNotification',
        defaultValue: false,
        portalShell: true,
    },

    EnableNotificationSeverityFilter: {
        name: 'enableNotificationSeverityFilter',
        defaultValue: false,
    },

    // Testing only
    /** Enable notification settings page */
    EnableNotificationProxy: {
        name: 'apollo-enableNotificationProxy',
        defaultValue: false,
        portalShell: true,
    },

    /** Enable notification settings page title with Preview Suffix */
    DisableNotificationPreview: {
        name: 'disableNotificationPreview',
        defaultValue: false,
        portalShell: true,
    },

    /** Enable notification popout page icon */
    EnableNotificationsPopoutPage: {
        name: 'enableNotificationsPopoutPage',
        defaultValue: false,
        portalShell: true,
    },

    /** Enables showing the usage charts and allocation details for Robot Units */
    EnableRobotUnits: {
        name: 'EnableRobotUnits',
        defaultValue: false,
    },

    EnableRobotDisplayName: {
        name: 'EnableRobotDisplayName',
        defaultValue: false,
    },

    /** Enable the fake language to show localization keys */
    EnableLocKeysLanguage: {
        name: 'enable-loc-keys-language',
        defaultValue: false,
        portalShell: true,
    },

    EnabledScheduledOrgMigration: {
        name: 'enabledScheduledOrgMigration',
        defaultValue: false,
    },

    EnabledScheduledTenantMigration: {
        name: 'enabledScheduledTenantMigration',
        defaultValue: false,
    },

    EnableReferenceTokens: {
        name: 'EnableReferenceTokens',
        defaultValue: false,
    },

    EnableRevokePATByValue: {
        name: 'EnableRevokePATByValue',
        defaultValue: false,
    },

    EnableHomePageCarousel: {
        name: 'EnableHomePageCarousel',
        defaultValue: false,
    },

    EnableTemplateWidget: {
        name: 'EnableTemplateWidget',
        defaultValue: false,
    },

    EnableTemplateWidgetForEnterprise: {
        name: 'EnableTemplateWidgetForEnterprise',
        defaultValue: false,
    },

    EnableLicenseInheritance: {
        name: 'EnableLicenseInheritance',
        defaultValue: false,
    },

    EnableContentfulSideBar: {
        name: 'EnableContentfulSideBar',
        defaultValue: false,
    },

    EnableStudioWebSideBar: {
        name: 'EnableStudioWebSideBar',
        defaultValue: false,
    },

    /** Allows the server to query Contentful for items in draft state. This should only ever be enabled in non-production environments. */
    EnableContentfulPreviewContent: {
        name: 'EnableContentfulPreviewContent',
        defaultValue: false,
    },

    ExpressRouteEnabled: {
        name: 'expressRouteEnabled',
        defaultValue: false,
    },

    IPSecPolicyEnabled: {
        name: 'ipSecPolicyEnabled',
        defaultValue: false,
    },

    /** Enable Local storage overrides for env config fields */
    EnablePortalShellLocalStorageOverrides: {
        name: 'enable-portal-shell-localstorage-overrides',
        defaultValue: false,
        portalShell: true,
    },

    /** Enable using self auth in people picker */
    EnablePortalShellSelfAuthPeoplePicker: {
        name: 'enable-portal-shell-self-auth-people-picker',
        defaultValue: false,
        portalShell: true,
    },

    /** Enables insights as an unlicensed service */
    EnableInsightsIsNoLongerALicensedService: {
        name: 'insightsIsNoLongerALicensedService',
        defaultValue: false,
    },

    /** Enables task mining as an unlicensed service */
    EnableTaskminingIsNoLongerALicensedService: {
        name: 'taskminingIsNoLongerALicensedService',
        defaultValue: false,
    },

    EnableStudioWebScope: {
        name: 'EnableStudioWebScope',
        defaultValue: false,
    },

    EnableInsightsScope: {
        name: 'EnableInsightsScope',
        defaultValue: false,
    },

    EnableStudioToggleForEnterpriseAndPro: {
        name: 'EnableStudioToggleForEnterpriseAndPro',
        defaultValue: false,
    },

    EnableHideIntegrationService: {
        name: 'EnableHideIntegrationService',
        defaultValue: false,
    },

    /** Enables AiUnits allocation at tenant level */
    EnableAiuAllocationOnTenant: {
        name: 'EnableAiuAllocationOnTenant',
        defaultValue: true,
    },

    /** Enables Action Center navigation in Portal Tag Labels */
    EnablePortalTagActionCenterNavigation: {
        name: 'EnablePortalTagActionCenterNavigation',
        defaultValue: true,
    },

    EnableUpgradeDialogOffersRevamp: {
        name: 'EnableUpgradeDialogOffersRevamp',
        defaultValue: false,
        portalShell: true,
    },

    EnableOrchestratorDelete: {
        name: 'EnableOrchestratorDelete',
        defaultValue: false,
    },

    LogExportInGov: {
        name: 'LogExportInGov',
        defaultValue: false,
    },

    HomePageWidgetMap: {
        name: 'HomePageWidgetMap',
        // eslint-disable-next-line max-len
        defaultValue: '{"AUTOMATION_EXPRESS_USER":["FRE","Automations","Runs"],"CITIZEN_DEV":["FRE","RecommendationTemplates","Apps","Automations","Runs","Actions"],"DefaultFallBack":["FRE","RecommendationTemplates","Automations","Runs"],"ADMIN":["FRE","Tenants","RecommendationTemplates","Recommendation","LicenseAllocation","Automations","Runs","Actions"],"RPA_DEVELOPER":["FRE","RecommendationTemplates","Tenants","Recommendation","Automations","Runs","Actions"],"UNKNOWN":["RecommendationTemplates","Automations","Runs"]}',
    },

    /** Enables using 307 instead of 302 */
    EnableApolloPackagesRedirect307: {
        name: 'enableApolloPackagesRedirect307',
        defaultValue: false,
    },

    EnableInsightsDataMonitoring: {
        name: 'EnableInsightsDataMonitoring',
        defaultValue: false,
    },

    // Required for testing
    EnableAADTestConnectionBrowserPost: {
        name: 'EnableAADTestConnectionBrowserPost',
        defaultValue: false,
    },

    EnableInsightsExportConfig: {
        name: 'EnableInsightsExportConfig',
        defaultValue: '',
    },

    ShowPlatformManagementLicensingScopes: {
        name: 'showPlatformManagementLicensingScopes',
        defaultValue: true,
    },

    /** Hides the Apps UI customization toggle */
    HideAppsToggle: {
        name: 'HideAppsToggle',
        defaultValue: false,
    },

    /** Hides the Marketplace UI customization toggle */
    HideMarketplaceToggle: {
        name: 'HideMarketplaceToggle',
        defaultValue: false,
    },

    /** Hides the Studio UI customization toggle */
    HideStudioToggle: {
        name: 'HideStudioToggle',
        defaultValue: false,
    },

    EnableHomePageLocaleSplit: {
        name: 'EnableHomePageLocaleSplit',
        defaultValue: false,
    },

    EnableSRSScope: {
        name: 'EnableSRSScope',
        defaultValue: false,
    },

    EnableTestManagerScope: {
        name: 'EnableTestManagerScope',
        defaultValue: false,
    },

    EnableConnectionServiceUserScope: {
        name: 'EnableConnectionServiceUserScope',
        defaultValue: false,
    },

    EnableServiceConnections: {
        name: 'enable-service-connections',
        defaultValue: false,
    },

    EnableServiceConnectorBuilder: {
        name: 'enable-service-connectorbuilder',
        defaultValue: false,
    },

    EnableServiceProvisioning: {
        name: 'enable-service-provisioning',
        defaultValue: false,
    },

    EnableServiceElements: {
        name: 'enable-service-elements',
        defaultValue: false,
    },

    EnableSRSRealTimeEventsCollection: {
        name: 'EnableSRSRealTimeEventsCollection',
        defaultValue: false,
    },

    EnableSRSTemplatesRealTimeEventsCollection: {
        name: 'EnableSRSTemplatesRealTimeEventsCollection',
        defaultValue: false,
    },

    EnableSRSRedirectTemplateURL: {
        name: 'EnableSRSRedirectTemplateURL',
        defaultValue: false,
    },

    AuditServiceBackendId: {
        name: 'AuditServiceBackendId',
        defaultValue: '',
    },

    EnableCustomerManagedKeyErrorBanner: {
        name: 'EnableCustomerManagedKeyErrorBanner',
        defaultValue: false,
    },

    EnableRuFallbackConfiguration: {
        name: 'enableRuFallbackConfiguration',
        defaultValue: false,
    },

    EnableHighContrastLightTheme: {
        name: 'apollo-enableHighContrastLightTheme',
        defaultValue: false,
        portalShell: true,
    },

    EnableHighContrastDarkTheme: {
        name: 'apollo-enableHighContrastDarkTheme',
        defaultValue: false,
        portalShell: true,
    },

    EnableUnattendedOverAllocationPreventionFlow: {
        name: 'EnableUnattendedOverAllocationPreventionFlow',
        defaultValue: false,
    },

    ManageUsersMapping: {
        name: 'ManageUsersMapping',
        defaultValue: JSON.stringify({
            'orchestrator': '/orchestrator_/users',
            'actions': '/orchestrator_/users',
            'processes': '/orchestrator_/users',
            'aifabric': '/aifabric_/ai-app/tenant-user-management',
            'automationhub': '/automationhub_/admin/manage-users',
            'automationstore': '/automationhub_/admin/manage-users',
            'taskmining': '/taskmining_/app/users',
            'processmining': '/processmining_/admin/assign-roles',
            'insights': 'insights_/manageaccess',
        }),
    },

    EnableLeftRailExperiment: {
        name: 'apollo-enableLeftRailExperiment',
        defaultValue: false,
    },

    EnableApiCallsUsage: {
        name: 'EnableApiCallsUsage',
        defaultValue: false,
    },

    EnableTransportUnitsUsage: {
        name: 'EnableTransportUnitsUsage',
        defaultValue: false,
    },

    EnableIntegrationsDelete: {
        name: 'EnableIntegrationsDelete',
        defaultValue: false,
    },

    EnableAgenticOrchestrationDelete: {
        name: 'EnableAgenticOrchestrationDelete',
        defaultValue: false,
    },

    EnableTestManagerDelete: {
        name: 'EnableTestManagerDelete',
        defaultValue: false,
    },

    EnableGlobalAppRegistrations: {
        name: 'EnableGlobalAppRegistrations',
        defaultValue: false,
    },

    HideIntegrationServiceToggle: {
        name: 'HideIntegrationServiceToggle',
        defaultValue: false,
    },

    EnableAbTestingLoggedEvents: {
        name: 'enableAbTestingLoggedEvents',
        defaultValue: '[]',
        portalShell: true,
    },

    EnableConsumablesTab: {
        name: 'EnableConsumablesTab',
        defaultValue: true,
    },
    EnableShowAiuChartForProcessMining: {
        name: 'EnableShowAiuChartForProcessMining',
        defaultValue: false,
    },
    EnableShowAiuChartForIntegrationService: {
        name: 'EnableShowAiuChartForIntegrationService',
        defaultValue: false,
    },

    EnableApolloSwitchingOrgDialog: {
        name: 'apollo-enableSwitchingOrgDialog',
        defaultValue: false,
    },

    EnableApolloAct2Revamp: {
        name: 'apollo-enableAct2Revamp',
        defaultValue: false,
        portalShell: true,
    },

    /** If enabled, user is removed from groups in multiple licensing calls, as opposed to a single one,  in the new implementation.
     *  Used to synchronize with LA deployments on Cloud. **/
    EnableLegacyRemoveUserFromGroups: {
        name: 'EnableLegacyRemoveUserFromGroups',
        defaultValue: false,
    },

    EnableTokenValidation: {
        name: 'EnableTokenValidation',
        defaultValue: true,
    },

    EnableAvailableServiceRequestSkip: {
        name: 'EnableAvailableServiceRequestSkip',
        defaultValue: false,
    },

    EnableUseGovLinks: {
        name: 'EnableUseGovLinks',
        defaultValue: false,
    },

    HideInsightsToggle: {
        name: 'HideInsightsToggle',
        defaultValue: false,
    },

    EnableHideAcademyToggle: {
        name: 'EnableHideAcademyToggle',
        defaultValue: false,
    },

    EnableHideCustomerPortalToggle: {
        name: 'EnableHideCustomerPortalToggle',
        defaultValue: false,
    },

    EnableHideAiCenterToggle: {
        name: 'EnableHideAiCenterToggle',
        defaultValue: false,
    },

    EnableHideAutomationHubToggle: {
        name: 'EnableHideAutomationHubToggle',
        defaultValue: false,
    },

    EnableHideCommunicationsMiningToggle: {
        name: 'EnableHideCommunicationsMiningToggle',
        defaultValue: false,
    },

    EnableHideProcessMiningToggle: {
        name: 'EnableHideProcessMiningToggle',
        defaultValue: false,
    },

    EnableHideAgentsToggle: {
        name: 'EnableHideAgentsToggle',
        defaultValue: false,
    },

    EnableHideAssistantToggle: {
        name: 'EnableHideAssistantToggle',
        defaultValue: false,
    },

    EnableHideAgenticOrchestrationToggle: {
        name: 'EnableHideAgenticOrchestrationToggle',
        defaultValue: false,
    },

    EnableInsightsForAll: {
        name: 'EnableInsightsForAll',
        defaultValue: false,
    },

    EnablePortalUberClient: {
        name: 'EnablePortalUberClient',
        defaultValue: false,
    },

    EnableAADClientCertificate: {
        name: 'EnableAADClientCertificate',
        defaultValue: false,
    },

    EnableSubmitIdea: {
        name: 'EnableSubmitIdea',
        defaultValue: false,
    },

    EnableTenantAdminControl: {
        name: 'EnableTenantAdminControl',
        defaultValue: false,
    },

    EnableProvisionWithEntitlementsInsights: {
        name: 'EnableProvisionWithEntitlementsInsights',
        defaultValue: false,
    },

    EnableProvisionWithEntitlementsAutomationHub: {
        name: 'EnableProvisionWithEntitlementsAutomationHub',
        defaultValue: false,
    },

    EnableProvisionWithEntitlementsProcessMining: {
        name: 'EnableProvisionWithEntitlementsProcessMining',
        defaultValue: false,
    },

    EnableProvisionWithEntitlementsTestManager: {
        name: 'EnableProvisionWithEntitlementsTestManager',
        defaultValue: false,
    },

    EnableUserLicensingMigration: {
        name: 'EnableUserLicensingMigration',
        defaultValue: false,
    },

    EnableSwitchOffUserLicensingAfterMigration: {
        name: 'EnableSwitchOffUserLicensingAfterMigration',
        defaultValue: false,
    },

    EnableUserLicenseManagementDisabledBanner: {
        name: 'EnableUserLicenseManagementDisabledBanner',
        defaultValue: false,
    },

    EnableRUIntervalMigration: {
        name: 'EnableRUIntervalMigration',
        defaultValue: false,
    },

    HideSAMLServiceCertificateUsage: {
        name: 'HideSAMLServiceCertificateUsage',
        defaultValue: false,
    },

    EnableUnifiedAuditExperience: {
        name: 'EnableUnifiedAuditExperience',
        defaultValue: false,
    },

    EnableUnifiedAuditExperienceToggle: {
        name: 'EnableUnifiedAuditExperienceToggle',
        defaultValue: false,
    },

    EnableKMSClientCertificate: {
        name: 'EnableKMSClientCertificate',
        defaultValue: false,
    },

    SamlMaximumProvisioningRules: {
        name: 'SamlMaximumProvisioningRules',
        defaultValue: 1000,
    },

    CorsAllowOptions: {
        name: 'CorsAllowOptions',
        defaultValue: '{"allowOrigins": ["*"],"allowDomains": []}',
    },

    // TODO: Remove this feature flag starting with sprint S150
    /** Enables showing the insights dashboard on the organization level */
    EnableInsightsDashboardLicensePage: {
        name: 'EnableInsightsDashboardLicensePage',
        defaultValue: false,
    },

    EnableAdminOrgConsent: {
        name: 'EnableAdminOrgConsent',
        defaultValue: false,
    },

    EnableMultipleOrgConsents: {
        name: 'EnableMultipleOrgConsents',
        defaultValue: false,
    },

    EnableSentry: {
        name: 'EnableSentry',
        defaultValue: false,
    },

    EnableCheckAccess: {
        name: 'EnableCheckAccess',
        defaultValue: false,
    },

    EnableOrchRoleAssignmentForAX: {
        name: 'EnableOrchRoleAssignmentForAX',
        defaultValue: false,
    },

    EnableServiceIsVisible: {
        name: 'EnableServiceIsVisible',
        defaultValue: false,
    },

    /** Controls UI for Dedicated environment */
    EnableOnDedicated: {
        name: 'EnableOnDedicated',
        defaultValue: false,
    },

    EnableSAMLAuthNToggle: {
        name: 'EnableSAMLAuthNToggle',
        defaultValue: false,
    },

    EnableIpRestrictionGridRefactor: {
        name: 'EnableIpRestrictionGridRefactor',
        defaultValue: false,
    },

    EnableAzureB2CAuthentication: {
        name: 'EnableAzureB2CAuthentication',
        defaultValue: false,
    },

    EnableAzureB2CAuthenticationDefaultIdp: {
        name: 'EnableAzureB2CAuthenticationDefaultIdp',
        defaultValue: false,
    },

    EnableAuthLogDebugger: {
        name: 'EnableAuthLogDebugger',
        defaultValue: false,
    },

    EnableFpsDocsUrl: {
        name: 'apollo-enableFpsDocsUrl',
        defaultValue: false,
        portalShell: true,
    },

    EnableNewAccountAndGroupsUX: {
        name: 'EnableNewAccountAndGroupsUX',
        defaultValue: false,
    },

    EnableNewAccountAndGroupsUXToggle: {
        name: 'EnableNewAccountAndGroupsUXToggle',
        defaultValue: false,
    },

    EnableAlertDuration: {
        name: 'apollo-enableAlertDuration',
        defaultValue: false,
        portalShell: true,
    },

    EnableToastManager: {
        name: 'EnableToastManager',
        defaultValue: false,
    },

    EnableAlwaysProvisionedServices: {
        name: 'EnableAlwaysProvisionedServices',
        defaultValue: false,
    },

    EnableLogExportButtonOrchestrator: {
        name: 'EnableLogExportButtonOrchestrator',
        defaultValue: false,
    },

    EnableLogExportButtonInsights: {
        name: 'EnableLogExportButtonInsights',
        defaultValue: false,
    },

    DisableEtagGeneration: {
        name: 'DisableEtagGeneration',
        defaultValue: false,
    },

    EnableAiTrustLayerAuditExport: {
        name: 'EnableAiTrustLayerAuditExport',
        defaultValue: false,
    },

    EnableAiTrustLayerAuditSource: {
        name: 'EnableAiTrustLayerAuditSource',
        defaultValue: false,
    },

    EnableAiTrustLayerAuditPiiStatus: {
        name: 'EnableAiTrustLayerAuditPiiStatus',
        defaultValue: false,
    },

    EnableOrgLevelManageAccess: {
        name: 'EnableOrgLevelManageAccess',
        defaultValue: false,
    },

    EnableTenantTagging: {
        name: 'EnableTenantTagging',
        defaultValue: false,
    },

    EnableMicrofrontends: {
        name: 'EnableMicrofrontends',
        defaultValue: false,
    },

    EnableAuditPageFeedbackButton: {
        name: 'EnableAuditPageFeedbackButton',
        defaultValue: false,
    },

    EnableIXP: {
        name: 'apollo-enableIXP',
        defaultValue: false,
    },

    EnableCheckAccessFolderSupport: {
        name: 'EnableCheckAccessFolderSupport',
        defaultValue: false,
    },

    EnableTenantsAndOrgInfoUseAllInfoApi: {
        name: 'EnableTenantsAndOrgInfoUseAllInfoApi',
        defaultValue: false,
    },

    EnablePrivacyAndSecuritySettings: {
        name: 'EnablePrivacyAndSecuritySettings',
        defaultValue: true,
    },

    EnableUnifiedAuditSearch: {
        name: 'EnableUnifiedAuditSearch',
        defaultValue: false,
    },

    EnableAzureRefreshTokenExpiryInterceptor: {
        name: 'EnableAzureRefreshTokenExpiryInterceptor',
        defaultValue: false,
    },

    EnableSAMLCustomIdentifierToggle: {
        name: 'EnableSAMLCustomIdentifierToggle',
        defaultValue: false,
    },

    EnablePricingV2: {
        name: 'apollo-enablePricingV2',
        defaultValue: false,
        portalShell: true,
    },

    EnableHideAuth0ApiAccess: {
        name: 'EnableHideAuth0ApiAccess',
        defaultValue: false,
    },

    EnableALMEndpointConfiguration: {
        name: 'EnableALMEndpointConfiguration',
        defaultValue: false,
    },

    EnableAADMultiTenantIntegration: {
        name: 'EnableAADMultiTenantIntegration',
        defaultValue: false,
    },

    EnableMultiTenantPreviewBadge: {
        name: 'EnableMultiTenantPreviewBadge',
        defaultValue: false,
    },

    EnableIntegrationServicePromoBanner: {
        name: 'EnableIntegrationServicePromoBanner',
        defaultValue: false,
    },

    EnableRoleAssignmentsExport: {
        name: 'EnableRoleAssignmentsExport',
        defaultValue: false,
    },

    EnableCMKGrantConsent: {
        name: 'EnableCMKGrantConsent',
        defaultValue: false,
    },

    DataFabricRebranding: {
        name: 'apollo-dataFabricRebranding',
        defaultValue: false,
        portalShell: true,
    },

    EnableDataFabricKey: {
        name: 'apollo-enableDataFabricKey',
        defaultValue: false,
        portalShell: true,
    },

    EnableASClusterHealthPortal: {
        name: 'EnableASClusterHealthPortal',
        defaultValue: false,
    },

    EnableSsoProvisioningEntitlements: {
        name: 'EnableSsoProvisioningEntitlements',
        defaultValue: false,
    },

    EnableEligibleForMultiRegionEntitlements: {
        name: 'EnableEligibleForMultiRegionEntitlements',
        defaultValue: false,
    },

    EnableCanaryTenantEntitlements: {
        name: 'EnableCanaryTenantEntitlements',
        defaultValue: false,
    },

    EnableUiBrandingEntitlements: {
        name: 'EnableUiBrandingEntitlements',
        defaultValue: false,
    },

    EnablePatRevamp: {
        name: 'EnablePatRevamp',
        defaultValue: false,
    },

    AzureActiveDirectoryMultiTenantClientId: {
        name: 'AzureActiveDirectoryMultiTenantClientId',
        defaultValue: '',
    },

    MultiTenantCmkClientId: {
        name: 'MultiTenantCmkClientId',
        defaultValue: '',
    },

    EnableSecuritySettingsTabIpRestriction: {
        name: 'EnableSecuritySettingsTabIpRestriction',
        defaultValue: true,
    },

    EnableExternalAppGridRefactor: {
        name: 'EnableExternalAppGridRefactor',
        defaultValue: false,
    },

    EnableTestCloudOrganizationAndUserEntitlements: {
        name: 'EnableTestCloudOrganizationAndUserEntitlements',
        defaultValue: false,
    },

    EnableEligibleForResourceCatalogueTagsEntitlement: {
        name: 'EnableEligibleForResourceCatalogueTagsEntitlement',
        defaultValue: false,
    },

    EnableWaitForOrchestratorFirstLogin: {
        name: 'EnableWaitForOrchestratorFirstLogin',
        defaultValue: false,
    },

    EnableDataAccessPoliciesGovernance: {
        name: 'EnableDataAccessPoliciesGovernance',
        defaultValue: false,
    },

    EnableInviteUserFilePicker: {
        name: 'EnableInviteUserFilePicker',
        defaultValue: false,
    },

    /** Enable multiple redirect URIs for external applications */
    EnableMultipleRedirectUrlsExternalApps: {
        name: 'EnableMultipleRedirectUrlsExternalApps',
        defaultValue: false,
    },

    EnableMockBucketRead: {
        name: 'EnableMockBucketRead',
        defaultValue: false,
    },
    ProductVersion: {
        name: 'apollo-productVersion',
        defaultValue: '2.2510.2',
        portalShell: true,
    },
};

export type IFeatures = {
    [K in keyof typeof FeaturesDefinitions]: IFeature;
};

export const Features = FeaturesDefinitions satisfies IFeatures;

export const DefaultValuesMap = Object.keys(Features).reduce((accumulator, current) => {
    const value = Features[current as keyof IFeatures];
    accumulator[value.name] = value.defaultValue;
    return accumulator;
}, {} as Record<string, boolean | string | number>);

export const PortalShellFeatureFlags = Object.values(Features)
    .filter((featureInformation: IFeature) => !!featureInformation.portalShell);
